import { FunctionComponent, useCallback } from 'react'

import config from '@config'
import translate from '@i18n'
import useAuthentication from '@hooks/useAuthentication'
import useDisableThirdPartyScripts from '@hooks/useDisableThirdPartyScripts'
import useUser from '@hooks/useUser'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import EmbeddedContent from '@components/EmbeddedContent'
import LoginOverlay from '@components/Tool/LoginOverlay'

const {
  loop: { widgetUrl },
} = config

interface LoopProps {
  id: string
  loginRequired: boolean
}

export const Loop: FunctionComponent<LoopProps> = ({
  id: loopId,
  loginRequired,
}) => {
  const disableThirdPartyScripts = useDisableThirdPartyScripts()
  const userData = useUser()
  const { login } = useAuthentication()
  const onLogin = useCallback(
    () => login({ prefix: `FOR_${loopId}` }),
    [loopId, login],
  )

  if (disableThirdPartyScripts) {
    return null
  }

  const loopUrl = `${widgetUrl}?hearkenId=${loopId}`
  const isLocked = loginRequired && userData?.email_only !== false

  return isLocked ? (
    <LoginOverlay
      text={`${
        userData?.email_only
          ? translate('formIO.noEmailOnlyRequiredText')
          : translate('formIO.loginRequiredText')
      }`}
      buttonText={`${
        userData?.email_only
          ? translate('formIO.noEmailOnlyRequiredButtonText')
          : translate('formIO.loginRequiredButtonText')
      }`}
      onClick={onLogin}
    />
  ) : (
    <EmbeddedContent url={loopUrl} withSSO={true} />
  )
}

const widget = {
  kind: ['widget', 'tool', 'loop'],
  component: Loop,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
